$(document).on("turbolinks:load", function () {
  var $devFundSlider = $(".js-devFund-slider")

  if ($devFundSlider.length > 0) {
    var $percentText = $(".js-devFund-percentText")
    var $amountText = $(".js-devFund-amountText")
    var $dataBoxText = $(".js-dataBox-devFundText")

    function updateDevFundDisplay(value) {
      var rawAmount = parseInt($amountText.attr("data-amount-after-fees"), 10)
      var totalPrice = (rawAmount / 100) * (value / 100)
      var totalPriceRounded = totalPrice.toFixed(2)

      $percentText.text(value)
      $amountText.text(totalPriceRounded)
      $dataBoxText.text("$" + totalPriceRounded)
    }

    updateDevFundDisplay($devFundSlider.val())

    $devFundSlider.on("input", function () {
      updateDevFundDisplay($(this).val())
    })
  }
})
